import { alpha } from '@mui/material/styles';
import { Box, Card, CardContent, Container, Typography } from '@mui/material';
import PageBanner from '../../components/Common/PageBanner';
import SectionHeading from '../../components/Common/SectionHeading';
import { certifications, pageContent, partners } from '../../data/siteData';

function CertificationsPage() {
  const content = pageContent.certificationsPage;

  return (
    <Box sx={{ bgcolor: '#1a0533', color: '#ffffff', minHeight: '100%' }}>
      <PageBanner {...content.banner} />
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
        <SectionHeading
          eyebrow={content.heading.eyebrow}
          title={content.heading.title}
          subtitle={content.heading.subtitle}
          light
        />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
            gap: 3,
          }}
        >
          {certifications.map((item) => {
            const Icon = item.icon;
            return (
              <Card key={item.name} elevation={0} sx={{ bgcolor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(201,168,76,0.24)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: 3.5,
                      display: 'grid',
                      placeItems: 'center',
                      bgcolor: alpha('#c9a84c', 0.14),
                      color: '#f1d98f',
                      mb: 2.25,
                    }}
                  >
                    <Icon sx={{ fontSize: 32 }} />
                  </Box>
                  <Typography variant="h4" sx={{ color: '#ffffff', mb: 1.1 }}>{item.name}</Typography>
                  <Typography sx={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.75 }}>{item.description}</Typography>
                </CardContent>
              </Card>
            );
          })}
        </Box>

        <Box sx={{ mt: 5, p: 2, border: '1px solid rgba(201,168,76,0.2)', borderRadius: 4, overflow: 'hidden' }}>
          <Typography sx={{ color: '#c9a84c', fontWeight: 800, mb: 2 }}>{content.partnersLabel}</Typography>
          <Box className="partner-marquee">
            <Box className="partner-marquee-track">
              {[...partners, ...partners].map((partner, index) => (
                <Box key={`${partner}-${index}`} className="partner-logo-box">
                  {partner}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default CertificationsPage;
